/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { GetUserQueryResponse, GetUserPathParams, GetUser404 } from '../types/GetUser.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getGetUserUrl(id: GetUserPathParams['id']) {
  const res = { method: 'GET', url: `/users/${id}` as const };
  return res;
}

/**
 * @summary Get user by ID
 * {@link /users/:id}
 */
export async function getUser(id: GetUserPathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetUserQueryResponse, ResponseErrorConfig<GetUser404>, unknown>({
    method: 'GET',
    url: getGetUserUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
